<template>
    <div class="modal fade" id="advancedSearchModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content border-0 shadow-lg" style="border-radius: 15px;">
                <div class="modal-header bg-teal text-white" style="border-radius: 15px 15px 0 0;">
                    <h5 class="modal-title font-weight-bold" id="exampleModalLabel">
                        <i class="fas fa-search-plus mr-2"></i> Búsqueda Avanzada
                    </h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="applyFilters">
                        <!-- Identidad -->
                        <h6 class="text-teal font-weight-bold border-bottom pb-2 mb-3">Identidad</h6>
                        <div class="form-row">
                            <div class="form-group col-md-3">
                                <label>No. Empleado</label>
                                <input type="text" class="form-control form-control-sm" v-model="filters.no_employee">
                            </div>
                            <div class="form-group col-md-3">
                                <label>RFC</label>
                                <input type="text" class="form-control form-control-sm" v-model="filters.rfc">
                            </div>
                             <div class="form-group col-md-3">
                                <label>Nacionalidad</label>
                                <input type="text" class="form-control form-control-sm" v-model="filters.nationality">
                            </div>
                            <div class="form-group col-md-3">
                                <label>Visa USA</label>
                                <select class="form-control form-control-sm" v-model="filters.usa_visa">
                                    <option value="">Todas</option>
                                    <option value="1">Sí</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                        </div>

                        <!-- Datos Laborales -->
                        <h6 class="text-teal font-weight-bold border-bottom pb-2 mb-3 mt-2">Datos Laborales</h6>
                         <div class="form-row">
                            <div class="form-group col-md-3">
                                <label>Tipo Jornada</label>
                                <input type="text" class="form-control form-control-sm" v-model="filters.workday_type">
                            </div>
                            <div class="form-group col-md-3">
                                <label>Esquema</label>
                                <select class="form-control form-control-sm" v-model="filters.hiring_scheme">
                                    <option value="">Todos</option>
                                    <option value="planta">Planta</option>
                                    <option value="temporal">Temporal</option>
                                    <option value="honorarios">Honorarios</option>
                                </select>
                            </div>
                             <div class="form-group col-md-3">
                                <label>Salario</label>
                                <input type="number" class="form-control form-control-sm" v-model="filters.salary" placeholder="Mínimo">
                            </div>
                             <div class="form-group col-md-3">
                                <label>Fecha Ingreso</label>
                                <input type="date" class="form-control form-control-sm" v-model="filters.admission_date">
                            </div>
                        </div>

                        <!-- Equipo -->
                         <h6 class="text-teal font-weight-bold border-bottom pb-2 mb-3 mt-2">Equipo Asignado</h6>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label>Marca PC</label>
                                <input type="text" class="form-control form-control-sm" v-model="filters.computer_brand">
                            </div>
                            <div class="form-group col-md-6">
                                <label>Serie PC</label>
                                <input type="text" class="form-control form-control-sm" v-model="filters.computer_serial">
                            </div>
                        </div>

                        <!-- Educación -->
                        <h6 class="text-teal font-weight-bold border-bottom pb-2 mb-3 mt-2">Formación</h6>
                        <div class="form-row">
                             <div class="form-group col-md-4">
                                <label>Nivel Educativo</label>
                                <input type="text" class="form-control form-control-sm" v-model="filters.education_level">
                            </div>
                            <div class="form-group col-md-4">
                                <label>Título</label>
                                <input type="text" class="form-control form-control-sm" v-model="filters.degree_title">
                            </div>
                            <div class="form-group col-md-4">
                                <label>Inglés</label>
                                <input type="text" class="form-control form-control-sm" v-model="filters.english_level">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer bg-light border-0" style="border-radius: 0 0 15px 15px;">
                    <button type="button" class="btn btn-link text-muted" @click="resetFilters">
                        <i class="fas fa-eraser mr-1"></i> Limpiar filtros
                    </button>
                    <button type="button" class="btn btn-link text-muted" data-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-teal px-4 shadow-sm" @click="applyFilters">
                        <i class="fas fa-search mr-1"></i> Aplicar Búsqueda
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
    name: 'AdvancedSearchModal',
    data() {
        return {
            filters: {
                no_employee: '',
                rfc: '',
                nationality: '',
                usa_visa: '',
                workday_type: '',
                hiring_scheme: '',
                salary: '',
                admission_date: '',
                computer_brand: '',
                computer_serial: '',
                education_level: '',
                degree_title: '',
                english_level: ''
            }
        };
    },
    methods: {
        applyFilters() {
            // Filter out empty values to keep URL clean
            let activeFilters = {};
            for (const key in this.filters) {
                if (this.filters[key] !== '' && this.filters[key] !== null) {
                    activeFilters[key] = this.filters[key];
                }
            }
            this.$emit('search', activeFilters);
            $('#advancedSearchModal').modal('hide');
        },
        resetFilters() {
            for (const key in this.filters) {
                this.filters[key] = '';
            }
        }
    }
};
</script>

<style scoped>
.bg-teal { background-color: #0f766e !important; }
.text-teal { color: #0f766e !important; }
.btn-teal {
    background-color: #0f766e;
    color: white;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.875rem;
}
.btn-teal:hover {
    background-color: #0d6e66;
    color: white;
}
</style>
